import { createStore } from 'vuex';
import skippersModule from './modules/skippers/index.js';
import requestsModule from './modules/requests/index.js';
import authModule from './modules/auth/index.js';

const store = createStore({
  modules: {
    skippers: skippersModule,
    requests: requestsModule,
    auth: authModule
  }
});

export default store;
